export default "__VITE_ASSET__Dm82r1Px__"